
import { defineComponent, reactive, ref } from "vue";
import mAxiosApi from "@/api";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import ContactNotifPicker from "@/components/still/ContactNotifPicker.vue";

export default defineComponent({
  name: "contact-quick-create",
  components: {
    ContactNotifPicker,
  },
  props: {
    linkToSite: {
      type: Number,
      default: null,
    },
    clientSociete: {
      type: Number,
      default: null,
    },
    layout: {
      type: String,
      default: "card",
      validator: (v: string) => ["card", "table"].includes(v),
    },
    showNotifs: {
      type: Boolean,
      default: true,
    },
    defaultNotifCodes: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  emits: ["created", "cancel"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const saving = ref(false);
    const selectedNotifs = ref<string[]>([]);

    const form = reactive({
      con_civilite: 0,
      con_prenom: "",
      con_nom: "",
      con_tel1: "",
      con_tel2: "",
      con_mail: "",
    });

    const resetForm = () => {
      form.con_civilite = 0;
      form.con_prenom = "";
      form.con_nom = "";
      form.con_tel1 = "";
      form.con_tel2 = "";
      form.con_mail = "";
      selectedNotifs.value = [];
    };

    const onCancel = () => {
      resetForm();
      emit("cancel");
    };

    const saveContact = async () => {
      if (!form.con_prenom.trim() || !form.con_nom.trim()) {
        ElMessage({
          showClose: true,
          message: t("Veuillez renseigner le prénom et le nom du contact."),
          type: "error",
        });
        return;
      }

      const payload: Record<string, unknown> = {
        con_civilite: form.con_civilite,
        con_prenom: form.con_prenom.trim(),
        con_nom: form.con_nom.trim(),
        con_tel1: form.con_tel1,
        con_tel2: form.con_tel2,
        con_mail: form.con_mail,
      };

      if (props.linkToSite && props.linkToSite > 0) {
        payload.con_knum_adr = props.linkToSite;
      }

      if (props.clientSociete && props.clientSociete > 0) {
        payload.con_knum_societe = props.clientSociete;
      }

      if (props.showNotifs && selectedNotifs.value.length > 0) {
        payload.notifs = [...selectedNotifs.value];
      }

      saving.value = true;
      try {
        const response = await mAxiosApi.post("addContact", payload);
        const results = response.data?.results;
        const conSeq =
          results && typeof results === "object" && results.con_seq
            ? Number(results.con_seq)
            : 0;

        emit("created", {
          con_seq: conSeq,
          con_prenom: form.con_prenom.trim(),
          con_nom: form.con_nom.trim(),
          con_mail: form.con_mail,
          con_tel1: form.con_tel1,
          con_tel2: form.con_tel2,
          notifs_actifs: results?.notifs_actifs || [],
        });
        resetForm();
      } catch (err) {
        console.error(err);
        ElMessage({
          showClose: true,
          message: t("Une erreur est survenue lors de la création du contact."),
          type: "error",
        });
      } finally {
        saving.value = false;
      }
    };

    return {
      form,
      saving,
      selectedNotifs,
      onCancel,
      saveContact,
    };
  },
});
